import React from 'react';
import DefaultButton from 'components/Utils/NewDefaultButton';
import { logout } from 'careand-redux/actions/logout';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import Icon from 'components/Utils/NewIcon';
import './style.scss';
import TopBar from 'scenes/HomePatient2/TopBar';

const PatientError = () => {
  const dispatch = useAppDispatch();

  return (
    <div className="page patient-error-boundary">
      <TopBar title="Error" />
      <div className="page-content padded-box">
        <Icon src="circle-exclamation" width="50px" className="red" />
        <span className="error-title">Something went wrong</span>
        <div className="buttons">
          <DefaultButton
            name="Reload App"
            icon="rotate-right"
            onClick={() => window.location.reload()}
          />
          <span>or</span>
          <DefaultButton
            name="Sign Out"
            icon="right-from-bracket"
            className="red"
            onClick={() => dispatch(logout({ isManuallyTriggered: true }))}
          />
        </div>
      </div>
    </div>
  );
};

export default PatientError;
